module.exports = __webpack_public_path__ + "img/vi.3ec35056.png";